import React from 'react';
import {UploadImage} from 'components/UI/Image';
import {DateTime} from 'components/UI/DateTime';
import {withRouter} from 'react-router-dom';

class ItemRequest extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="item-request-wrap" onClick={() => this.props.history.push(`/user/my-requests/${this.props.id}`)}>
        <div className='product-content-wrap'>
          <div className='product-content-image-wrap mb10'>
            <UploadImage transform="crop" type="PRODUCT" width="189" height="127" image={this.props.product && this.props.product.images && this.props.product.images[this.props.product.images.length -1]} />
          </div>
          <p className='product-content-name'>{this.props.product && this.props.product.name}</p>
        </div>
        <div className='request-content-wrap'>
          <p className='request-content-title mb10'>Nội dung yêu cầu</p>
          <p className='request-content mb10'>{this.props.description}</p>
          <p className='time'><DateTime dateTime={this.props.createdAt}/></p>
          {/*<p className='conversations'>10 trao đổi</p>*/}
        </div>
      </div>
    );
  }
}

export default withRouter(ItemRequest);



// WEBPACK FOOTER //
// ./components/users/sub-view/my-request-content/ItemRequest.jsx